module.exports = __webpack_public_path__ + "static/img/10.42252b31.png";